/**
 * ProfileReportTable.jsx
 */

import React, { useState } from 'react';
import { defineMessages } from 'react-intl';

import GovBrPagination from './GovBrPagination';

const messages = defineMessages({
  noResults: {
    id: 'No results found',
    defaultMessage: 'No results found',
  },
  loading: {
    id: 'Loading...',
    defaultMessage: 'Loading...',
  },
  applyFilters: {
    id: 'Apply filters to generate the report',
    defaultMessage: 'Apply filters to generate the report',
  },
  tipTitle: {
    id: 'Tip',
    defaultMessage: 'Tip',
  },
  tipText: {
    id: 'tip.text.csv',
    defaultMessage:
      'To export the report, click on the "Export CSV" button. The file will be generated and downloaded automatically. Depending on the size of the report, this may take a few moments.',
  },
});

const ProfileReportTable = ({
  items = [],
  total = 0,
  currentPage = 1,
  pageSize = 30,
  loading = false,
  onPageChange,
  onPageSizeChange,
  filtered = false,
  onExportCsv,
  isExporting = false,
  intl,
}) => {
  const [accordionOpen, setAccordionOpen] = useState(false);

  if (loading) {
    return (
      <div className="text-center my-5">
        {intl.formatMessage(messages.loading)}
      </div>
    );
  }

  if (!filtered) {
    return (
      <div className="br-message info">
        <div className="content">
          {intl.formatMessage(messages.applyFilters)}
        </div>
      </div>
    );
  }

  if (!items.length) {
    return (
      <div className="br-message info">
        <div className="content">{intl.formatMessage(messages.noResults)}</div>
      </div>
    );
  }

  return (
    <>
      <div className="br-table">
        <table>
          <thead>
            <tr>
              <th>Nome do Usuário</th>
              <th>CPF</th>
              <th>Email</th>
              <th>Perfis</th>
            </tr>
          </thead>

          <tbody>
            {items.map((user, idx) => (
              <tr key={user.email || idx}>
                <td>{user.name}</td>
                <td>{user.cpf || '-'}</td>
                <td>{user.email || '-'}</td>
                <td>
                  <ul className="m-0 pl-3">
                    {user.roles.map((role) => (
                      <li key={role.id}>{role.title}</li>
                    ))}
                  </ul>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <GovBrPagination
        total={total}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />

      <div className="d-flex align-items-center mt-3">
        <button
          className="br-button primary mr-2"
          onClick={onExportCsv}
          disabled={isExporting}
        >
          {isExporting ? 'Exportando...' : 'Exportar CSV'}
        </button>
        <button
          className="br-button link d-flex align-items-center"
          type="button"
          aria-controls="id9"
          aria-expanded={accordionOpen ? true : undefined}
          onClick={() => setAccordionOpen(!accordionOpen)}
        >
          <span className="icon">
            <i
              className={`fas fa-angle-${accordionOpen ? 'up' : 'down'}`}
              aria-hidden="true"
            ></i>
          </span>
          <span className="title">{intl.formatMessage(messages.tipTitle)}</span>
        </button>
      </div>

      <div className="row mt-3" id="accordion1">
        <div
          className="content p-2 bg-gray-10"
          id="id9"
          aria-hidden={!accordionOpen}
          style={{ display: accordionOpen ? 'block' : 'none' }}
        >
          {intl.formatMessage(messages.tipText)}
        </div>
      </div>
    </>
  );
};

export default ProfileReportTable;
